<template>
  <header class="header">
    <div class="container-fluid u-bg--grey">
        <div class="wrapper">
        <!-- Logo -->
        <Logo/>
        <!-- Burger -->
          <div class="menu-burger" @click="setNavActive()">
            <div class="menu-toggle" :class="{active: navActive}">Menu</div>
            <span class="text">Menu</span>
          </div>
        <!-- Nav -->
        <header-nav :navActive="navActive" @setNavActive="setNavActive()"/>
      </div>
    </div>
  </header>
</template>

<script>
import Logo from './Logo'
import HeaderNav from './HeaderNav'

export default {
  name: 'v-header',

  data: () => {
    return {
      navActive: false
    }
  },
  methods: {
    setNavActive() {
      this.navActive = !this.navActive
    }
  },
  components: {
    Logo,
    HeaderNav
  }
}
</script>

<style lang="scss">

  .header {
    width: 100%;

    .container-fluid {
    	border-radius: 0 0 3px 3px;
    	background:rgba(255,255,255,0.98);
    }

    .wrapper {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 0 rem(135px);

      @include mq($until: SM) {
        padding: 0 rem(10px) 0 rem(5px);
      }

      @include mq($from: SM, $until: LG) {
        padding: 0 rem(50px) 0 rem(50px);
      }

      .menu-burger {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor:pointer;
        z-index:6;

        $transitionSpeed: .25s;
        $transitionEasing: ease-in-out;

        .menu-toggle {
          position: relative;
          display: block;
          width: 100%;
          height: rem(16px);
          background: transparent;
          border-color: transparent;
          border-top: 2px solid color(blue);
          border-bottom: 2px solid color(blue);
          color: color(blue);
          font-size: 0;
          transition: all $transitionSpeed $transitionEasing;
          z-index: 4;

          &:before,
          &:after {
            content: '';
            display: block;
            width: 100%;
            height: 2px;
            position: absolute;
            top: 50%;
            left: 50%;
            background: currentColor;
            transform: translate(-50%, -50%);
            transition: transform $transitionSpeed $transitionEasing;
          }
        }

        div {
          &:hover {
            z-index: 10;
          }

          &:focus {
            outline: none;
          }

          &.active {
            border-color: transparent;

            &:before {
              transform: translate(-50%, -50%) rotate(45deg);
            }

            &:after {
              transform: translate(-50%, -50%) rotate(-45deg);
            }
          }
        }

        .text {
          font-size: rem(8px);
          line-height: rem(14px);
          text-transform: uppercase;
          font-weight: 700;
          padding-top: rem(2px);
        }

        @include mq($from: MD) {
          display: none;
        }
      }
    }
  }


</style>
